import { EpisodesLayout } from '@wix/podcasts-common/dist/settings';
import { TPADeviceType } from '@wix/podcasts-common/dist/tpa';

import { ISettings } from '../lib/settings/types';

function isGridLayoutSelected(settings: ISettings, deviceType: TPADeviceType) {
  return settings.main.episodesLayout === EpisodesLayout.GRID;
}

function getItemsPerRow(
  pageWidth: number,
  itemWidth = 292,
  margin = 16,
  pageOffsets = 4,
): number {
  const count = Math.floor(
    (pageWidth - pageOffsets * 2) / (itemWidth + margin * 2),
  );
  return Math.min(Math.max(count, 2), 5);
}

function getEpisodesPerPage(
  settings: ISettings,
  deviceType: TPADeviceType,
  pageWidth?: number,
): number {
  if (!isGridLayoutSelected(settings, deviceType)) {
    return settings.main.episodesPerPage;
  }

  return (
    settings.main.episodeRowsPerPage * getItemsPerRow(pageWidth || Infinity)
  );
}

function isShowHeaderEnabled(settings: ISettings): boolean {
  return settings.main.showHeader;
}

export { isGridLayoutSelected, getEpisodesPerPage, isShowHeaderEnabled };
